import { ReferenceCompute } from "./ReferenceCompute.js";
/**
 * @internal scope: workspace
 */
export function normalizeComputeReferenceArgs(params) {
    if (params.length === 1) {
        const [options] = params;
        return options;
    }
    const dependencies = params.slice(0, -1);
    const compute = params[params.length - 1];
    return { dependencies, compute };
}
export function computeRef(...params) {
    return new ReferenceCompute(normalizeComputeReferenceArgs(params));
}
